/** Set when a guest views a template landing page; read after signup onboarding. */
export const PENDING_TEMPLATE_STORAGE_KEY = "drillflo_pending_template_id";

/**
 * Returns pathname if it is a safe same-origin in-app path, otherwise null.
 * Rejects protocol-relative URLs and external targets.
 */
export function safeInternalPath(raw) {
  if (!raw || typeof raw !== "string") return null;
  if (!raw.startsWith("/") || raw.startsWith("//")) return null;
  return raw;
}

/** @param {string | null | undefined} path */
export function templateIdFromTemplatesPath(path) {
  if (!path || typeof path !== "string") return null;
  const m = path.match(/^\/templates\/([^/]+)\/?$/);
  return m ? m[1] : null;
}
